import Container from '@/components/Container';
import { usePodcastStore } from '../store/usePodcastStore';
import LessonCard from '@/components/Learn/Lesson';
import Button from '@/components/Button';
import { ArrowPathIcon, PlayIcon } from '@heroicons/react/24/solid';
import { useNavigate } from 'react-router-dom';
import isPodcastDone from '../utils/is-done';
import AnimatedFadeInComponent from '@/components/AnimatedFadeInComponent';

export default function ListPodcasts() {
  const { page, podcasts } = usePodcastStore();
  const navigate = useNavigate();

  return (
    <Container className="!mt-sh-60">
      <div className=" col-span-12 lg:col-start-11 lg:col-end-3 ">
        <h3 className=" font-larken text-sh-md">{page?.page?.latestTitle}</h3>
        <div className="flex flex-col gap-sh-30">
          {podcasts?.map((podcast) => {
            const { isDone, progress } = isPodcastDone(podcast);
            return (
              <AnimatedFadeInComponent key={podcast.id}>
                <LessonCard
                  truncateDescription={progress > 0 ? true : false}
                  key={podcast.id}
                  title={podcast.attributes?.title || ''}
                  description={podcast.attributes?.briefDescription || ''}
                  url={`/podcast/${podcast.attributes?.slug}`}
                  thumbnail={podcast.attributes?.cover}
                  watchLabel={'Play'}
                  progress={progress}
                  button={
                    <div className="flex items-center gap-4">
                      <Button
                        theme={isDone ? 'outline' : 'solid'}
                        onClick={() => navigate(`/podcast/${podcast.attributes?.slug}`)}>
                        {isDone ? (
                          <ArrowPathIcon className="inline-block h-4 w-4" />
                        ) : (
                          <PlayIcon className="inline-block h-4 w-4" />
                        )}{' '}
                        {isDone ? 'PLAY AGAIN' : 'PLAY'}
                      </Button>
                    </div>
                  }
                />
              </AnimatedFadeInComponent>
            );
          })}
        </div>
      </div>
    </Container>
  );
}
